// libs
import React from 'react';

// components
import SizeGuide from 'shared/layouts/SizeGuide';
import { OverlaySheetContext, SHEET_TRANSITION } from 'shared/components/OverlaySheet';

// styles
import { OverlaySheet, Container } from './styles';

function SizeGuideBottomSheet({
  onClose,
  onSizeSelect,
  selectedSize,
  isAddedToCart,
  addToCart,
  selectedSizeName,
  outOfStockSizes,
  stockRemainingMap,
}: {
  onClose: () => void;
  onSizeSelect?: (sizeName: string) => void;
  selectedSize?: ProductDetail.ISizeOption;
  isAddedToCart?: boolean;
  addToCart?: () => void;
  selectedSizeName?: string;
  outOfStockSizes?: string[];
  stockRemainingMap?: Record<string, number>;
}) {
  return (
    <OverlaySheet
      onHide={onClose}
      transitionFrom={SHEET_TRANSITION.RIGHT}
      navKey="sizeguide"
      disableNav
    >
      <OverlaySheetContext.Consumer>
        {({ doHide }) => (
          <Container>
            <SizeGuide
              onClose={doHide}
              onSizeSelect={onSizeSelect}
              selectedSize={selectedSize}
              isAddedToCart={isAddedToCart}
              addToCart={addToCart}
              selectedSizeName={selectedSizeName}
              outOfStockSizes={outOfStockSizes}
              stockRemainingMap={stockRemainingMap}
            />
          </Container>
        )}
      </OverlaySheetContext.Consumer>
    </OverlaySheet>
  );
}

export default SizeGuideBottomSheet;
